const path = require('path');
const root = 'api';
const version = 'v1';

function baseUrl(domain, tenantUserId=null, url) {
  const baseUrl = path.join(root, version, `tenants/${domain}/`);
  if (tenantUserId) {
    return path.join(baseUrl + `users/${tenantUserId}/`);
  }
  return baseUrl;
}

function baseAdminUrl(domain) {
  return path.join(baseUrl(domain), 'admin/');
}

function baseAdminDownloadUrl(domain) {
  return path.join(baseAdminUrl(domain), 'download/');
}

function tenantUserUrl(domain, tenantUserId) {
  return path.join(baseUrl(domain) + `users/${tenantUserId}/`);
}

export default {
  currentUser: () => {
    return path.join(root, version, 'users/current/');
  },
  currentUserImage: () => {
    return path.join(root, version, 'users/current/image/');
  },
  currentUserPassword: () => {
    return path.join(root, version, 'users/current/password/');
  },
  currentUserTenants: () => {
    return path.join(root, version, 'users/current/tenants/');
  },
  currentUserTenantInvitationCodes: () => {
    return path.join(root, version, 'users/current/invitation-codes/');
  },
  currentUserTenantInvitationCodeAccept: () => {
    return path.join(root, version, 'users/current/invitation-codes/accept/');
  },
  currentUserTenantInvitationCodeDecline: () => {
    return path.join(root, version, 'users/current/invitation-codes/decline/');
  },
  emailAvailability: () => {
    return path.join(root, version, 'email/availability/');
  },
  emailVerificationCode: () => {
    return path.join(root, version, 'auth/email/code/verification/');
  },
  emailVerificationCodeEmail: () => {
    return path.join(root, version, 'lookup/email/email-verification-code/');
  },
  experiencePeriodCategories: path.join(root, version, 'experience-period-categories/'),
  globalVariables: () => {
    return path.join(root, version, 'global-variables/');
  },
  languageCodes: path.join(root, version, 'language-codes/'),
  newTenant: () => {
    return path.join(root, version, 'tenants/new/');
  },
  newUser: () => {
    return path.join(root, version, 'users/new/');
  },
  passwordReset: () => {
    return path.join(root, version, 'auth/password-reset/');
  },
  passwordResetCode: () => {
    return path.join(root, version, 'auth/email/code/password-reset/');
  },
  passwordResetCodeEmail: () => {
    return path.join(root, version, 'lookup/email/password-reset-code/');
  },
  skillStatusTypes: path.join(root, version, 'skill-status-types/'),
  ssoEmailDomain: path.join(root, version, 'auth/login/'),
  ssoAuthorizationUrl: () => {
    return path.join(root, version, 'auth/sso/authorization-url/');
  },
  tenants: (domain = null) => {
    return path.join(root, version, 'tenants/', domain != null ? `${domain}/` : '');
  },
  tenantInvitationCodeEmail: () => {
    return path.join(root, version, 'lookup/email/tenant-invitation-code/');
  },
  tenantInvitationCodeTenant: () => {
    return path.join(root, version, 'lookup/tenant/tenant-invitation-code/');
  },
  timezoneCodes: path.join(root, version, 'timezone-codes/'),
  tokenPair: () => {
    return path.join(root, version, 'auth/token/pair/');
  },
  tokenRefresh: () => {
    return path.join(root, version, 'auth/token/refresh/');
  },
  tokenRevoke: () => {
    return path.join(root, version, 'auth/token/revoke/');
  },
  aggregatedSkills: (domain) => {
    return path.join(baseUrl(domain), 'skills/aggregate/');
  },
  currentTenant: (domain) => {
    return path.join(baseUrl(domain), 'current/');
  },
  currentTenantUser: (domain) => {
    return path.join(baseUrl(domain), 'users/current/');
  },
  experienceTypes: (domain) => {
    return path.join(baseUrl(domain), 'experience-types/');
  },
  experts: (domain) => {
    return path.join(baseUrl(domain), 'search/experts/');
  },
  jobCategories: (domain) => {
    return path.join(baseUrl(domain), 'job-categories/');
  },
  mediaTypes: (domain) => {
    return path.join(baseUrl(domain), 'media-types/');
  },
  roleTypes: (domain, tenantUserId, targetTenantUserId) => {
    return path.join(baseUrl(domain, tenantUserId), `role-types/${targetTenantUserId}/`);
  },
  searchExpertsInputSuggestions: (domain) => {
    return path.join(baseUrl(domain), 'search/experts/input/suggestions/');
  },
  skillSimilarities: (domain) => {
    return path.join(baseUrl(domain), 'skill-similarities/');
  },
  skillAliases: (domain, skillId, skillAliasId = null) => {
    return path.join(baseUrl(domain), 'skills/${skillId}/', skillAliasId != null ? `${skillAliasId}/` : '');
  },
  skillsByName: (domain) => {
    return path.join(baseUrl(domain), 'skills/by-name/');
  },
  skills: (domain, skillId = null) => {
    return path.join(baseUrl(domain), 'skills/', skillId != null ? `${skillId}/` : '');
  },
  surveyCategorySkills: (domain, surveyId) => {
    return path.join(baseUrl(domain), `surveys/${surveyId}/skills/`);
  },
  surveyCategoryTenantUserSkills: (domain, tenantUserId, surveyId, surveyCategoryId = null, tenantUserSkillId = null) => {
    return path.join(
      tenantUserUrl(domain, tenantUserId),
      `surveys/${surveyId}/categories/`,
      surveyCategoryId !== null ? `${surveyCategoryId}/skills/` : 'skills/',
      tenantUserSkillId !== null ? `${tenantUserSkillId}/` : ''
    );
  },
  surveyDownloadFile: (domain, surveyCode = null) => {
    return path.join(
      baseAdminDownloadUrl(domain),
      'surveys/',
      surveyCode !== null ? `${surveyCode}/` : '',
      'file/',
    );
  },
  surveyFile: (domain) => {
    return path.join(baseAdminUrl(domain), 'survey-file/');
  },
  surveyPublish: (domain, surveyCode) => {
    return path.join(baseAdminUrl(domain), `surveys/${surveyCode}/publish/`);
  },
  surveys: (domain, surveyCode = null) => {
    return path.join(baseAdminUrl(domain), 'surveys/', surveyCode !== null ? `${surveyCode}/` : '');
  },
  surveyStates: (domain, surveyId) => {
    return path.join(baseAdminUrl(domain), `surveys/${surveyId}/states/`);
  },
  tagInputSuggestions: (domain) => {
    return path.join(baseUrl(domain), 'tag-suggestions/');
  },
  tenantAccount: (domain) => {
    return path.join(baseUrl(domain), 'account/');
  },
  tenantDiagnose: (domain) => {
    return path.join(baseUrl(domain), 'diagnose/');
  },
  tenantInvitationCodes: (domain, invitationCodeId = null) => {
    return path.join(baseUrl(domain), 'invitation-codes/', invitationCodeId != null ? `${invitationCodeId}/` : '');
  },
  tenantParams: (domain) => {
    return path.join(baseUrl(domain), 'params/');
  },
  tenantTeamInvisibleSkills: (domain, tenantTeamId, tenantTeamInvisibleSkillId = null) => {
    return path.join(baseUrl(domain), `teams/${tenantTeamId}/invisible-skills/`, tenantTeamInvisibleSkillId != null ? `${tenantTeamInvisibleSkillId}/` : '');
  },
  tenantTeams: (domain, tenantTeamId = null) => {
    return path.join(baseUrl(domain), 'teams/', tenantTeamId != null ? `${tenantTeamId}/` : '');
  },
  tenantTeamPermissions: (domain, tenantTeamCode, tenantTeamPermissionId = null) => {
    return path.join(baseUrl(domain), `teams/${tenantTeamCode}/permissions/`, tenantTeamPermissionId != null ? `${tenantTeamPermissionId}/` : '');
  },
  tenantTeamSkills: (domain, tenantTeamId, tenantTeamSkillId = null) => {
    return path.join(baseUrl(domain), `teams/${tenantTeamId}/skills/`, tenantTeamSkillId != null ? `${tenantTeamSkillId}/` : '');
  },
  tenantTeamTenantUsers: (domain, tenantTeamId, tenantTeamTenantUserId = null) => {
    return path.join(baseUrl(domain), `teams/${tenantTeamId}/users/`, tenantTeamTenantUserId != null ? `${tenantTeamTenantUserId}/` : '');
  },
  tenantTeamTenantUserSkills: (domain, tenantTeamId) => {
    return path.join(baseUrl(domain), `teams/${tenantTeamId}/users/skills`);
  },
  tenantTeamView: (domain, tenantTeamCode) => {
    return path.join(baseUrl(domain), `team-views/${tenantTeamCode}/`);
  },
  tenantUser: (domain, tenantUserId) => {
    return path.join(baseUrl(domain), 'users/', `${tenantUserId}/`);
  },
  tenantUserCoedits: (domain, tenantUserId) => {
    return path.join(baseUrl(domain, tenantUserId), 'coedits/');
  },
  tenantUserDiagnose: (domain, tenantUserId) => {
    return path.join(baseUrl(domain, tenantUserId), 'diagnose/');
  },
  tenantUsers: (domain, tenantUserId = null) => {
    return path.join(baseUrl(domain), 'users/', tenantUserId != null ? `${tenantUserId}/` : '');
  },
  tenantUserLinks: (domain, tenantUserId, tenantUserLinkId = null) => {
    return path.join(baseUrl(domain, tenantUserId), 'links/', tenantUserLinkId != null ? `${tenantUserLinkId}/` : '');
  },
  tenantUserSkills: (domain, tenantUserId, skillId = null) => {
    return path.join(tenantUserUrl(domain, tenantUserId), 'skills/', skillId != null ? `${skillId}/` : '');
  },
  tenantUserSurveys: (domain, tenantUserId, surveyCode = null) => {
    return path.join(baseUrl(domain, tenantUserId), 'surveys/', surveyCode !== null ? `${surveyCode}/` : '');
  },
  tenantUserSurveyState: (domain, tenantUserId, surveyId) => {
    return path.join(baseUrl(domain, tenantUserId), `surveys/${surveyId}/state/`,);
  },
  tenantUserVisits: (domain, tenantUserId, tenantUserVisitId = null) => {
    return path.join(baseUrl(domain, tenantUserId), 'visits/', tenantUserVisitId != null ? `${tenantUserVisitId}/` : '');
  },
  userSuggestions: (domain) => {
    return path.join(baseUrl(domain), 'user-suggestions/');
  },
};
